// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { Message, MessageGroup, User } from "../../../Utilities";
import { MediaAttachmentFormValues } from "../MediaAttachment";
import { MessageTopicFormValues } from "../MessageTopic";

export type Base = {
	body: Message["body"];
	messageGroupID: MessageGroup["id"] | null;
};

export type Create = Base & {
	mediaAttachments: MediaAttachmentFormValues.CreateInMessage[];
	messageTopic: MessageTopicFormValues.CreateInMessage[];
};

export type CreateRequiredKey = Extract<keyof Create, "messageGroupID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	body: "",
	mediaAttachments: [],
	messageGroupID: null,
	messageTopic: [],
};

export type Detail = Base & {
	createdAt: Message["createdAt"] | null;
	lastEditedAt: Message["lastEditedAt"] | null;
	isRemoved: Message["isRemoved"];
	authorID: User["id"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInMessageGroup = Omit<Create, "messageGroupID">;

export type CreateInMessageGroupRequiredKey = Exclude<CreateRequiredKey, "messageGroupID">;

export type CreateInMessageGroupSubset<K extends keyof CreateInMessageGroup = keyof CreateInMessageGroup> = Pick<
	CreateInMessageGroup,
	CreateInMessageGroupRequiredKey | K
>;

export const blankItemInMessageGroup: CreateInMessageGroup = omitKeys(initialCreate, ["messageGroupID"]);
